var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-morph-definitions_list" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.$store.getters["app/shortDefDataReady"],
              expression: "! $store.getters['app/shortDefDataReady']",
            },
          ],
          staticClass:
            "alpheios-morph-definitions_list__definitions--placeholder",
        },
        [
          _c("progress-bar", {
            attrs: { text: _vm.l10n.getText("PLACEHOLDER_LEX_DATA_LOADING") },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.definitions, function (definition, dindex) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.getters["app/shortDefDataReady"],
                expression: "$store.getters['app/shortDefDataReady']",
              },
            ],
            key: definition.ID,
            staticClass: "alpheios-morph-definitions_list__definition",
            attrs: { "data-lemmakey": _vm.lexeme.lemma.ID },
          },
          [
            _vm.definitions.length > 1
              ? _c(
                  "span",
                  {
                    staticClass:
                      "alpheios-morph-definitions_list__definition_index",
                  },
                  [_vm._v(_vm._s(_vm.definitionIndex(dindex)))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("shortdef", {
              attrs: {
                definition: definition,
                languageCode: _vm.lexeme.lemma.languageCode,
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }